import React, { useEffect, useState } from "react";
import GenericTable from "../GenericTable/GenericTable";
import { CircularProgress } from "@mui/material";
import config from "../../../config";

const invoiceColumns = [
  { id: "store_name", label: "Store Name" },
  {
    id: "invoice_number",
    label: "Invoice Number",
    render: (row) => row.invoice_number || "N/A"
  },
  {
    id: "billing_date",
    label: "Billing Date",
    render: (row) => row.billing_date || "N/A"
  },
  {
    id: "payment_status",
    label: "Payment Status",
    render: (row) => row.payment_status || "N/A"
  },
  {
    id: "subscription",
    label: "Description",
    render: (row) => row.subscription || "N/A"
  },
  {
    id: "total_amount",
    label: "Amount",
    render: (row) => row.total_amount != null ? `$${Number(row.total_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "N/A"
  },
  {
    id: "due_date",
    label: "Due Date",
    render: (row) => row.due_date || "N/A"
  }
];

const downloadInvoice = async (row) => {
  try {
    // if (!config.isAuthenticated()) {
    //   alert("Please login to view invoices.");
    //   return;
    // }

    // Fetch signed URL from backend
    const response = await fetch(
      `${config.API_BASE_URL}/client/revenue/invoices/${row.invoice_id}/download-url`,
      {
        method: "GET",
        headers: config.getHeaders(),
      }
    );

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("Session expired. Please login again.");
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    if (result?.success && result?.data?.download_url) {
      // Open invoice in new tab using the signed URL
      window.open(result.data.download_url, '_blank');
    } else {
      throw new Error(result?.message || "Failed to generate invoice URL");
    }
  } catch (err) {
    console.error("Invoice view error:", err);
    alert(err.message || "Failed to open invoice.");
  }
};

function InvoicesList() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // API constants
  const CLIENT_ID = config.clientId;

  useEffect(() => {
    const controller = new AbortController();

    const fetchInvoices = async () => {
      try {
        setLoading(true);
        setError(null);

        const url = `${config.API_BASE_URL}/client/billing/history?client_id=${CLIENT_ID}&page=1&limit=100`;

        const res = await fetch(url, {
          headers: config.getHeaders(),
          signal: controller.signal
        });

        if (!res.ok) {
          throw new Error(`HTTP ${res.status}: Failed to fetch invoices`);
        }

        const json = await res.json();

        if (!json.success) {
          throw new Error(json.message || "Failed to fetch invoices");
        }

        // Set the invoices data
        const normalized = Array.isArray(json.data)
          ? json.data.map((item) => ({
            id: item.invoice_id,
            ...item,
          }))
          : [];
        console.log("Normalized rows:", normalized);
        console.log("Rows length:", normalized.length);

        setRows(normalized);

      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error("[InvoicesList] Fetch error:", error);
          setError(error.message);
          setRows([]); // Fallback to empty array
        }
      } finally {
        setLoading(false);
      }
    };

    fetchInvoices();

    return () => controller.abort();
  }, [CLIENT_ID]);

  const customActions = [
    {
      label: "Download Invoice",
      icon: "download",
      color: "primary",
      onClick: downloadInvoice,
    },
  ];

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "2rem",
        padding: "2rem",
        textAlign: "center"
      }}>
        <p style={{ color: "red", marginBottom: "1rem" }}>
          Failed to load invoices: {error}
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: "0.5rem 1rem",
            backgroundColor: "#1976d2",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <GenericTable
      title="Invoice Details"
      subtitle=""
      columns={invoiceColumns}
      rows={rows}
      showView={false}
      showEdit={false}
      showDelete={false}
      dropdownFilters={["store_name", "payment_status", "subscription"]}
      // dateFilters={["billing_date", "due_date"]}
      customActions={customActions}
      customActionsHeader="Download Invoice"
    />
  );
}

export default InvoicesList;

